import React from "react"

import {
	Grid
} from "@mui/material"


import {
	Loading
} from "@sinossi/mates-react-library"

import {
	Action, DashboardResponse, PaginatedResponse,
	SessionResponse
} from "models"

import { MatesComponent, MatesComponentState } from "components/mates-component"
import { AssetList } from "pages"
import { UseRouterParams } from "services/router"
import {
	DashboardCard,
	DashboardCardsData,
	DashboardCardWithList
} from "."

interface DashboardLandlordProps extends UseRouterParams {
	dashboardData: DashboardResponse
	actions: PaginatedResponse<Action> | null
	notifications: PaginatedResponse<Action> | null

	refreshActions: () => void

	sessionData: SessionResponse
}
interface DashboardLandlordState extends MatesComponentState {
	loading: boolean
}
export class DashboardLandlord extends React.Component<DashboardLandlordProps, DashboardLandlordState> {

	private readonly matesComponent: MatesComponent<DashboardLandlordProps, DashboardLandlordState> = new MatesComponent(this)

	constructor(props: DashboardLandlordProps) {
		super(props)
		this.state = {
			...this.matesComponent.setupState(),
			loading: false
		}
	}

	render() {
		return (
			<>
				<Loading show={this.state.loading} />
				{
					!this.state.loading && <>
						<Grid container alignItems="stretch" spacing={2}>
							<Grid item xs={12} md={4} sx={{ height: '100%' }}>
								{this.props.actions &&
									<DashboardCardWithList
										cardType={DashboardCardsData.ACTIONS}
										data={this.props.actions}
										refreshPage={this.props.refreshActions}
										sessionData={this.props.sessionData}
										brand
									/>
								}
							</Grid>
							<Grid container item xs={12} md={4} sx={{ height: '100%' }} spacing={2} direction="column">
								<Grid item xs={12} md={6}>
									<DashboardCard
										cardType={DashboardCardsData.MY_ASSETS}
										value={3}
										percentage={0}
										notifications={0} />
								</Grid>
								<Grid item xs={12} md={6}>
									<DashboardCard
										cardType={DashboardCardsData.CONVERSION_RATE}
										value={2}
										isPercentage
										percentage={0}
										notifications={0} />
								</Grid>
							</Grid>
							<Grid container item xs={12} md={4} sx={{ height: '100%' }} spacing={2} direction="column">
								<Grid item xs={12} md={6} >
									<DashboardCard
										cardType={DashboardCardsData.MEAN_TIME_CONTRACT_START}
										value={"10 giorni"}
										percentage={0}
										notifications={0} />
								</Grid>
								<Grid item xs={12} md={6}>
									<DashboardCard
										cardType={DashboardCardsData.CONTRACT_VALUE}
										value={"10200 €"}
										percentage={0}
										notifications={0} />

								</Grid>
							</Grid>
							<Grid item xs={12}>
								<AssetList
									isInLandlordDashboard
									sessionData={this.props.sessionData}
								/>
							</Grid>
						</Grid >
					</>
				}
			</>
		)
	}
}
